import { RewardLog } from '@klubovna/api-client';
import { PaginationMetadata } from '@shared';

export interface RewardLogsState {
  rewardLogs: RewardLog[];
  loading: boolean;
  error: string | null;
  pagination: PaginationMetadata;
}

export const initialRewardLogsState: RewardLogsState = {
  rewardLogs: [],
  loading: false,
  error: null,
  pagination: {
    total: 0,
    page: 1,
    limit: 20,
    totalPages: 0,
  },
};

